// nextjsWhiteListPaths.js
'use strict';

import { LIVESTREAM_PATH } from './liveStreamConstants.js';

const MANAGE_PROFILE_WHITE_LIST_PATHS_REGEX = [
  '/manage-profile/account',
  '/manage-profile/manage',
  '/manage-profile/display-name',
  '/manage-profile/biography',
  '/manage-profile/account-linking',
  '/manage-profile/account-linking/web-authn',
  '/manage-profile/blocked-list',
  '/manage-profile/credit-card',
  '/manage-profile/credit-card/billing-email',
  '/manage-profile/receipt',
  '/manage-profile/receipt/information',
];

const SETTINGS_WHITE_LIST_PATHS_REGEX = [
  '/settings',
  '/settings/auto-addvalue',
  '/settings/journal',
  '/settings/vvip',
  '/settings/redeem',
  '/settings/bank-account',
  '/settings/notification',
  '/settings/preferences',
  '/settings/faq',
  '/settings/2257',
  '/settings/referral',
  '/settings/referral/result',
  '/settings/more',
  '/settings/more/debug',
  '/settings/more/drm',
  '/settings/more/about',
  '/settings/more/delete-account',
];

export const WHITE_LIST_PATHS_REGEX = [
  '/',
  '/video',
  '/explore',
  '/story',
  '/user-following-grid/:category',
  '/me/livestreamSession/:sessionId',
  '/me/livestreamSession/:sessionId/leaderboard',
  '/user-event',
  '/user-feed-grid/:category',
  '/user-leaderboard-grid/:category',
  '/hashtag/:hashtag',
  '/hashtag/:hashtag/:type',
  '/addvalue',
  '/messagePack/list',
  '/archive',
  '/archive/userId/:id/:listId',
  '/category/:categoryId',
  '/category/:categoryId/:listType',
  '/category-overview',
  '/leaderboard/:region/:category/:range',
  '/livestream/:id',
  '/referral',
  '/story/:messageId',
  '/shorts',
  '/shorts/ad/:cta',
  '/shorts/:messageId',
  '/shorts/:messageId/draft',
  '/shorts-categories/:category',
  '/story-preview/:messageId',
  '/flix-categories/:category',
  '/story-categories/:category',
  '/user-categories/:category',
  '/post/:messageId/clip/:range',
  '/post/:messageId',
  '/following',
  '/audio/:messageId',
  '/message/:messageId',
  '/messages/:messageId',
  '/product/:productId',
  '/profile/following',
  '/profile/follower',
  '/profile/subscriber',
  '/profile/subscribed',
  '/revenue',
  '/revenue/report/billing',
  '/revenue/report/daily',
  '/revenue/report/fanleaderboard',
  '/user/:userId',
  `/user/:userId/${LIVESTREAM_PATH}`,
  `/user/:userId/${LIVESTREAM_PATH}/chat`,
  '/user/:userId/:listType',
  '/user/:userId/:listType/:publishStatus',
  '/user/:userId/:chat',
  '/u/:username',
  '/u/:username/:listType',
  '/u/:username/:listType/:publishStatus',
  '/join/:progress',
  '/chat',
  '/chat/start',
  '/chat/:chatroomId',
  '/chat/:chatroomId/media',
  '/chat/:chatroomId/search',
  '/chat/:chatroomId/message/:messageId',
  '/chat/user/:userId',
  '/age-verify/:progress',
  '/search',
  '/search/:type/:category',
  '/search/:type',
  '/standalone/player/byteplus',
  '/standalone/contractor/*',
  '/campaigns/showcase',
  '/campaigns/showcase-story',
  '/tos',
  '/privacy',
  '/404',
  '/error',
  '/iframe',
  '/videos',
  '/login',
  '/signup',
  ...SETTINGS_WHITE_LIST_PATHS_REGEX,
  ...MANAGE_PROFILE_WHITE_LIST_PATHS_REGEX,
];
